import React, { useCallback, useEffect, useState } from "react";
import { Table, Button, Row, Col, Input, Pagination, Spin, App, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { QUIZ_REPORT, DOWNLOAD_QUIZ_REPORT } from "../../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import { LoadingOutlined, EyeFilled, DownloadOutlined } from "@ant-design/icons";

const QuizReport = () => {
  const { notification } = App.useApp();

  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [download_button, set_download_button] = useState(true);

  const DOWNLOAD_REPORT_ACTION = async (learner_id) => {
    try {
      const formData = new FormData();
      formData.append("learner_id", learner_id);

      const API_CALL = await DOWNLOAD_QUIZ_REPORT(formData);

      // --- SUCCESS CHECK ---
      if (API_CALL?.data?.status) {
        notification.success({
          message: "Download Successful",
          description: "Check the Download tab for your report",
        });
      }
      else {
        notification.error({
          message: "Download Failed",
          description: API_CALL?.data?.message || "Unable to download report.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Download Error",
        description: error?.message || "Something went wrong while downloading.",
      });
    }
  };



  const [table_data, set_table_data] = useState([]);
  const [current_page, set_current_page] = useState(1);
  const [total_records, set_total_records] = useState(0);
  const [page_size, set_page_size] = useState(10);

  const [search_query_title, set_search_query_title] = useState("");


  const fetchList = async (page, size, search) => {
    set_pagination_loader(true);

    const form = new FormData();
    form.append("page", page);
    form.append("per_page", size);
    if (search) form.append("search", search);

    const API = await QUIZ_REPORT(form);

    if (API?.data?.status) {
      const data = API.data.data;

      set_table_data(data?.results || []);
      set_current_page(Number(data?.current_page || page));
      set_total_records(Number(data?.count || 0));
      set_page_size(Number(data?.page_size || size));
    }

    setLoader(false);
    set_pagination_loader(false);
  };


  useEffect(() => {
    fetchList(1, page_size, search_query_title);
  }, []);


  const pagination_on_change = (page, size) => {
    set_current_page(page);
    set_page_size(size);
    fetchList(page, size, search_query_title);
  };


  const fetchResultsTitle = useCallback(
    debounce((value) => {
      set_search_query_title(value);
      fetchList(1, page_size, value);
    }, 500),
    [page_size]
  );

  const handleInput = (e) => {
    fetchResultsTitle(e.target.value);
  };


  const columns = [
    {
      title: "Name",
      render: (_, r) => (
        <span>
          {r.learner_id__first_name} {r.learner_id__last_name}
        </span>
      ),
    },
    {
      title: "Email",
      render: (_, r) => <span>{r.learner_id__email}</span>,
    },
    {
      title: "Total Quiz",
      dataIndex: "chapter_count",
    },
    {
      title: "Action",
      render: (_, r) => (
        <>
          <Button
            type="primary"
            size="small"
            onClick={() =>
              navigate(`/report/quiz-report/${btoa(r.learner_id)}`)
            }
          >
            <EyeFilled />
          </Button>

          <Button
            size="small"
            variant="solid"
            color="green"
            style={{ marginLeft: "10px" }}
            onClick={() => DOWNLOAD_REPORT_ACTION(r.learner_id)}
            disabled={!download_button}
          >
            < DownloadOutlined />
          </Button>

        </>
      ),
    },
  ];

  return (
    <div className="lms-body">
      <Card>
      <h2>Quiz Report</h2>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={18} lg={20}>
            <Input
              addonBefore={<span>Name & Email</span>}
              onChange={handleInput}
              placeholder="Search by Name or Email"
              size="large"
            />
          </Col>
        </Row>

        {loader ? (
          <CulsightPageLoader />
        ) : pagination_loader ? (
          <div style={{ textAlign: "center", padding: "60px" }}>
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          </div>
        ) : (
          <>
            <Table
              columns={columns}
              dataSource={table_data}
              pagination={false}
              rowKey={(r, i) => i}
              style={{ marginTop: 15 }}
            />


            {total_records > 0 && (
              <div style={{ float: "right", marginTop: 20 }}>
                <Pagination
                  current={current_page}
                  total={total_records}
                  pageSize={page_size}
                  showSizeChanger
                  pageSizeOptions={[10, 20, 50, 100]}


                  onChange={(page, size) => pagination_on_change(page, size)}

                  onShowSizeChange={(page, size) => {
                    set_page_size(size);
                    pagination_on_change(1, size);
                  }}

                  className="no-search-pagination"
                />

                <style>
                  {`
                  .no-search-pagination .ant-select-selection-search-input {
                    display: none !important;
                  }
                `}
                </style>
              </div>
            )}
          </>
        )}

      </Card>


    </div>
  );
};

export default QuizReport;
